import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Content, Page} from "../audit.models";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {UntypedFormControl} from "@angular/forms";
import {AuditServiceService} from "../audit-service.service";
import {MatSnackBar} from "@angular/material/snack-bar";
 // import  * as _ from './assets/css/bootstrap.css'

@Component({
  selector: 'app-logging-sms',
  templateUrl: './logging-sms.component.html',
  styleUrls: ['./logging-sms.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LoggingSmsComponent implements OnInit, AfterViewInit {
  auditsPage: Page<Content> = new Page<Content>();
  displayedColumns: string[] = ['receivedPhoneNumber', 'provider', 'contentSms', 'transactionId', 'status', 'action'];
  dataSource: MatTableDataSource<Content> = new MatTableDataSource<Content>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  page = 0;
  size = 10;
  loading = true;
  search = '';
  searchControl: UntypedFormControl = new UntypedFormControl();
  isSent: boolean = false;

  constructor(private auditService: AuditServiceService,
              private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    console.log("fetch Data...")
    this.loading = true;
    this.auditService.getAuditSms(this.search, this.page, this.size).subscribe(value => {
      this.auditsPage = value;
      this.loading = false;
      console.log('sms ', this.auditsPage)
      // this.dataSource.data = this.auditsPage.content;
    }, error => console.error(error));
  }

  linkify(text) {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function (url) {
      return '<a class="text-primary" href="' + url + '">' + url + '</a>';
    });
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  resentSms(transId) {
    this.isSent = true;
    this.auditService.sentSms(transId).subscribe(data => {
      // console.log(data)
      this._snackBar.open("Message renvoyer avec succès")
      this.fetchData();
      this.isSent =false;
    })
  }

  setPage(event: PageEvent) {
    if (event.pageSize != this.size) {
      this.size = event.pageSize;
      this.page = 0;
    } else {
      this.page = event.pageIndex;
    }
    this.fetchData();
  }

  applyFilter(event: KeyboardEvent) {

    if (this.search.length >= 2) {
      this.page = 0;
      this.fetchData();
    }
    if (this.search.length === 0) {
      this.fetchData()
    }
  }

  onSearch(event: KeyboardEvent) {
    console.log("Key ", event, this.search)
    if (this.search.length > 3) {
      this.page = 0
      this.fetchData();
    } else if (this.search.length === 0){
      this.page = 0
      this.fetchData();
    }

  }
  changePage(auditsPage: Page<Content>, option: string) {
    console.log(this.page)
    if(option == 'prev'){
      this.page = this.page - 1;
    }
    if(option == 'next'){
      this.page = this.page + 1;
    }
    this.fetchData();
  }

}
